import Modal, { ModalBody, ModalHeader } from '@ingka/modal';
import { ActionButton, StyledSheets, StyledSheetDiv, StyledToolbarButton, StyledTooltip } from '../../../../shared/styles/components/integrations.styles';

import { HideSubList } from './HideSubList';
import { List } from '@mui/material';
import { Switch, FormControlLabel } from '@mui/material';
import gearIcon from '@ingka/ssr-icon/paths/gear';
import { filterEmissionColumnsByRole, tableColumns } from '../table/ColumnDefs';
import { useAuth } from '../../../auth/state/auth.state';
import { useColumnOrderState } from '../../state/column-order.state';
import { useState } from 'react';

export const ColumnHideSheet = () => {
   const [isOpen, setIsOpen] = useState(false);
   const { canManageEmissionFactors } = useAuth();
   const resetOrder = useColumnOrderState((state) => state.resetOrder);
   const columnsMoveable = useColumnOrderState((state) => state.columnsMoveable);
   const toggleMoveableColumns = useColumnOrderState((state) => state.toggleMoveableColumns);

   const visibleMainColumns = filterEmissionColumnsByRole(tableColumns.main, canManageEmissionFactors);
   const visibleExpandedColumns = filterEmissionColumnsByRole(tableColumns.expanded, canManageEmissionFactors);

   return (
      <>
         <StyledTooltip title={'Hide/Show & reorder columns'}>
            <StyledToolbarButton
               onClick={() => {
                  setIsOpen(true);
               }}
               ssrIcon={gearIcon}
               text="Filter"
               iconOnly={true}
               small={true}
            />
         </StyledTooltip>
         <Modal visible={isOpen} handleCloseBtn={() => setIsOpen(false)}>
            <StyledSheets
               alignment={'right'}
               preserveAlignment={true}
               size={'small'}
               header={<ModalHeader title="Hide/Show columns" floating={false} />}
               footer={<></>}
            >
               <ModalBody style={{ padding: '1rem' }}>
                  <StyledSheetDiv style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                     <FormControlLabel
                        control={<Switch checked={columnsMoveable} onChange={toggleMoveableColumns} size="small" />}
                        labelPlacement="start"
                        sx={{ margin: 0 }}
                        label="Reorder columns"
                     />
                     {columnsMoveable && <ActionButton style={{ padding: 0 }} onClick={resetOrder}>Reset order</ActionButton>}
                  </StyledSheetDiv>
                  <List
                     sx={{
                        width: '100%',
                        height: '100%',
                        bgcolor: 'background.paper',
                        position: 'relative',
                        overflow: 'auto',
                        '& ul': { padding: 0 },
                     }}
                     subheader={<li />}
                  >
                     <HideSubList title={'Main table'} columns={visibleMainColumns} section={'main'} />
                     <HideSubList title={'Expanded table'} columns={visibleExpandedColumns} section={'expanded'} />
                  </List>
               </ModalBody>
            </StyledSheets>
         </Modal>
      </>
   );
};
